export default __webpack_public_path__ + "static/media/youtube.a0da86de.svg";